export default __webpack_public_path__ + "static/media/Bukhari.5e8432ad.jpg";